
import router from "../router";
import store from "../store";
import Vue from 'vue'

Vue.mixin({
  computed: {

    authorities () {
      return store.getters.authorities
    },
    currentUser () {
      return store.getters.curUser
    },
    currentUserDepartmentName () {
      return store.getters.userDepartmentName
    },
     currentCustomer () {
      return store.getters.curCustomer
    },
    currentCustomerLogicalId() {
      return store.getters.currentCustomerLogicalId
    }
  },
  methods: {
    historyBack () {
      router.go(-1)
    },
    userHasAuthority (authority) {
      return store.getters.authorities.includes(authority)
    }
  }

})

